import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Dashboard"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M21 1.5H3C2.17192 1.50083 1.50083 2.17192 1.5 3V21C1.50083 21.8281 2.17192 22.4992 3 22.5H21C21.8279 22.4988 22.4988 21.8279 22.5 21V3C22.4992 2.17192 21.8281 1.50083 21 1.5ZM21 8.25H10.5V3H21V8.25ZM9 8.25V3H3V8.25H9ZM3 21V9.75H21L21.0015 21H3ZM19.5 15.75H18V19.5H19.5V15.75ZM15 12H16.5V19.5H15V12ZM4.5 15.75C4.50248 17.82 6.17996 19.4975 8.25 19.5C10.3211 19.5 12 17.8211 12 15.75C12 13.6789 10.3211 12 8.25 12V13.5C9.49264 13.5 10.5 14.5074 10.5 15.75C10.5 16.9926 9.49264 18 8.25 18C7.00736 18 6 16.9926 6 15.75H4.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Dashboard.vue"]]);
